// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GUjs","content":"styles_content__3n5IX"};